/** @jsxImportSource @emotion/react */
import {
  Button,
  Container,
  getUniqueId,
  Icon,
  Input,
  Link,
  Stack,
  Text,
  VisuallyHidden,
} from "basis";
import { Separator } from "components/Separator/Separator";
import { Dispatch, FC, SetStateAction } from "react";

const MAX_ACCOUNTS = 5;

function addNewAccount(values) {
  const accounts = {
    ...values.accounts,
    [getUniqueId()]: "",
  };

  return { ...values, accounts };
}

function removeAccountUpdateFn(id) {
  return (values) => {
    const accounts = {
      ...values.accounts,
    };

    delete accounts[id];

    return { ...values, accounts };
  };
}
interface Props {
  accountIds: string[];
  setValues: Dispatch<SetStateAction<string>>;
}

export const Accounts: FC<Props> = ({ accountIds = [], setValues }) => (
  <Stack gap="8" width="100%" width-sm="400">
    {accountIds.map((id, index) => (
      <Container padding="5" hasBorder key={id}>
        <Stack gap="4" testId={`tpa-account-${index + 1}`}>
          <div
            css={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Text textStyle="subtitle2">
              <strong>{`Account number ${index + 1}`}</strong>
            </Text>
            {accountIds.length > 1 && (
              <Button
                variant="icon"
                onClick={() => {
                  setValues(removeAccountUpdateFn(id));
                }}
              >
                <Icon name="trash" />
                <VisuallyHidden>Remove account</VisuallyHidden>
              </Button>
            )}
          </div>
          <Separator />
          <Input name={`accounts.${id}`} label="" />
        </Stack>
      </Container>
    ))}
    {accountIds.length < MAX_ACCOUNTS && (
      <Link
        href="#"
        newTab={false}
        onClick={(e) => {
          e.preventDefault();
          setValues(addNewAccount);
        }}
      >
        Add another account
      </Link>
    )}
  </Stack>
);
